












import { Component, Vue } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'
import { mapState, mapMutations } from 'vuex'

@Component({
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any): boolean => gamblingContext.isAuthenticated
    })
  }
})
export default class SignupFirst extends Vue {
  @Mutation('setLogInModal') setLogInModal: any
}
